<template>
  <section>
    <div
      id="alertdeletionfbpagemodal"
      ref="alertdeletionfbpagemodal"
      class="modal modal-right fade"
      tabindex="-1"
    >
      <div
        class="modal-dialog modal-lg modal-dialog-slideout d-flex align-items-center justify-content-center"
        style="height: 100vh; max-width: 100vw; margin: 0;"
        role="document"
      >
        <div 
          class="modal-content p-0 text-515151"
        >
          <div class="modal-header bg-dark d-flex align-items-center">
            <h6 class="modal-title">
              <span>{{ $t("_ModalDeletion.Integration Warning") }}</span>
            </h6>
            <button
              type="button"
              class="close"
              ref="close"
              data-dismiss="modal"
              @click="closeModal()"
              aria-label="Close"
            >
              <span aria-hidden="true">&times;</span>
            </button>
          </div>

          <div
            id="product_promotion"
            class="modal-body p-0"
          >
            <div class="py-2 px-3 border-color-fafafa border-bottom-1">
              <i class="fa-solid fa-circle-info mr-2" />{{ $t('_ModalDeletion.Integration Infomation') }}
            </div>

            <div class="p-3 d-flex flex-column">
              <div
                class="box-chat-expire d-flex flex-row align-items-center justify-content-start"
              >
                <i class="fa-solid fa-circle-xmark text-warning-icon" />
                <div class="text-warning">
                  {{ $t('Found {pages} integrations have been deleted from the store because the user who connected them has removed the connection data with GoChat via the platform. If you wish to continue using it, please add integration again.') | replacePages(deletedPages) }}
                </div>
              </div>
            </div>

            <div class="card-body tab-content p-0 px-3">
              <!-- start deletion table -->
              <!-- <div class="tab-pane"> -->
              <div :class="[loadingTable ? 'loading' : '']">
                <div
                  :class="['mt-0 data-nowrap table-tag border-top border-right border-left', loadingTable]"
                  id="table_product_promotion"
                >
                  <div v-show="onload">
                    <div class="container">
                      <placeholder-content :is-load="true" />
                    </div>
                  </div>
                  <div
                    v-show="!onload"
                  >
                    <div
                      :class="['vuetable-wrapper ui basic segment overflow-y-auto']"
                    >
                      <vuetable
                        class="dataTable thead-bg-fafafa table-hover"
                        :api-mode="false"
                        :fields="table.fields"
                        data-path="data"
                        pagination-path=""
                        ref="vuetable"
                        :data-manager="dataManager"
                        @vuetable:pagination-data="onPaginationData"
                        :no-data-template="$t('No Data Available')"
                        :per-page.sync="pagination.perPage"
                        :current-page.sync="pagination.currentPage"
                        track-by="name"
                      >
                        <template
                          slot="ch"
                        >
                          <img
                            class="rounded pointer"
                            width="30"
                            height="30"
                            :src="$storeIndex.getImageGobalAssets('b-facebook')"
                            alt=""
                          >
                        </template>
                      </vuetable>
                    </div>
                  </div>
                </div>
              </div>
              <div class="datatable-footer p-3">
                <div class="dataTables_paginate paging_simple_numbers mb-0">
                  <vue-pagination 
                    :per-page="pagination.perPage" 
                    :records="pagination.total" 
                    v-model="pagination.currentPage" 
                    :options="pagination.options"
                    @paginate="onChangePage"
                  />
                </div>
              </div>
            </div>
            <!-- </div> -->
            <!-- end deletion table -->
          </div>
          <div 
            class="fixed-bottom border-top bg-light py-2" 
          >
            <div class="text-center">
              <button
                type="button"
                class="btn btn-primary btn-normal-font mr-3"
                style="height: 2.25rem !important;"
                @click="gotoGoSaas()"
              >
                <i class="fa-solid fa-circle-arrow-right mr-1" />{{ $t("Manage Integration") }}
              </button>
              <button
                type="button"
                class="btn btn-outline-ddd btn-normal-font"
                data-dismiss="modal"
                style="height: 2.25rem !important;"
                @click="closeModal()"
              >
                {{ $t("Cancel") }}
              </button>
            </div>
          </div>
        </div>
      </div>
    </div>
  </section>
</template>

<script>
import numeral from 'numeral';
import Vuetable from 'vuetable-2'
import PlaceholderContent from '@/plugins/PlaceholderContent.vue'
import VuePagination from 'vue-pagination-2';
import Api from "@/services/endpoint/central.service";
import pageFields from "./assets/page_fields.js";

export default {
  name: "ModalDeletionFBPages",
  components: {
    Vuetable,
    VuePagination,
    PlaceholderContent
  },
  data() {
    return {
      onload:false,
      isShow: false,
      deletedPages: 0,
      deletedPageItems: [],
      page: 1,
      limit: 10,
      loadingTable: "",
      table: {
        fields: pageFields,
      },
      pagination: {
        perPage: 10,
        total: 0,
        currentPage: 1,
        options: {
          chunk: 1,
          texts: {
            count:this.$t('Displaying {from} to {to} of {count} items'),
          }
        } 
      },
    };
  },
  computed: {
  },
  mounted() {
    // this.fetchDeletionLists();
    this.$nextTick(() => {
      if (this.$store.state.showedPageDisconnected && this.$store.state.showedPageUnlinked && !this.$store.state.showedPageDeleted && this.$store.state.itemsPageDeleted.length) {
        this.isShow = true;
        this.deletedPages = this.$store.state.itemsPageDeleted.length;
        this.deletedPageItems = this.$store.state.itemsPageDeleted;
      }
    })
  },
  watch: {
    "$store.state.showedPageDisconnected"() {
      if (this.$store.state.showedPageDisconnected && this.$store.state.showedPageUnlinked && !this.$store.state.showedPageDeleted && this.$store.state.itemsPageDeleted.length) {
        if ($('#alertdeletionfbpagemodal')) $('#alertdeletionfbpagemodal').modal('show');
        if ($(this.$refs.alertdeletionfbpagemodal)) $(this.$refs.alertdeletionfbpagemodal).modal('show');
        this.isShow = true;
        this.deletedPages = this.$store.state.itemsPageDeleted.length;
        this.deletedPageItems = this.$store.state.itemsPageDeleted;
      }
    },
    "$store.state.showedPageUnlinked"() {
      if (this.$store.state.showedPageDisconnected && this.$store.state.showedPageUnlinked && !this.$store.state.showedPageDeleted && this.$store.state.itemsPageDeleted.length) {
        if ($('#alertdeletionfbpagemodal')) $('#alertdeletionfbpagemodal').modal('show');
        if ($(this.$refs.alertdeletionfbpagemodal)) $(this.$refs.alertdeletionfbpagemodal).modal('show');
        this.isShow = true;
        this.deletedPages = this.$store.state.itemsPageDeleted.length;
        this.deletedPageItems = this.$store.state.itemsPageDeleted;
      }
    },
  },
  filters: {
    replacePages: function (text, value) {
      return text.replace('{pages}', numeral(value).format("0,0") || "0");
    },
  },
  methods: {
    closeModal() {
      this.$store.state.showedPageDeleted = true;
      if ($('#alertdeletionfbpagemodal')) $('#alertdeletionfbpagemodal').modal('hide');
      if ($(this.$refs.alertdeletionfbpagemodal)) $(this.$refs.alertdeletionfbpagemodal).modal('hide');
      this.isShow = false;
    },
    dataManager(sortOrder, pagination) {
      if (this.$store.state.tablePageDeleted || !this.$store.state.callAPIDeletionPage) {
        if (this.$store.state.tablePageDeleted.total) {
          this.$refs.vuetable.makePagination(this.$store.state.tablePageDeleted.total, 10);
        }
        this.$refs.vuetable.setData(this.$store.state.tablePageDeleted);
      } else {
        setTimeout(() => {
          this.fetchDeletionLists();
        }, 5000);
      }
    },
    async fetchDeletionLists() {
      let page = this.page;
      let limit = this.limit;

      this.onload = true;

      try {
        const request = await Api.Chat.getDeletionList(page, limit);

        if(request.status != 200) {
          throw ({message : "get deletion list failed"})
        }

        if (request.status == 200) {
          if (request.data && request.data.data && request.data.data.length) {
            this.$store.state.dataPageDeleted = request.data;
            this.$store.state.itemsPageDeleted = request.data.data;

            let data = this.$storeIndex.mutations.vueTableFormatJson(request);
            data = {
              data: data.data,
              current_page: request.data.currentPage || 1,
              from: request.data.from || 1,
              last_page: request.data.totalPages || 1,
              per_page: 10,
              prev: request.data.currentPage == 1 ? null : request.data.currentPage - 1,
              total: request.data.totalResults,
            }
            if (request.data.totalResults) {
              this.$refs.vuetable.makePagination(request.data.totalResults, 10);
            }
            this.$refs.vuetable.setData(data);
          }
        }
      } catch (error) {
        if (error.response && error.response.data && error.response.data.message == "token has expired") this.$storeIndex.gotoGoSaas(this);
        console.error(error.message)
      } finally {
        this.onload = false;
      }
    },
    onPaginationData(tablePagination) {
    },
    onChangePage(page) {
      this.page = page;
      this.fetchDeletionLists();
    },
    gotoGoSaas() {
      let self = this;
      if (self.$cookie.get("callbackUrl")) window.open(self.$cookie.get("callbackUrl") + "/app/integrations", '_blank').focus();
      else if (process.env.GOSAAS_BASE_URL) window.open(process.env.GOSAAS_BASE_URL, '_blank').focus();
    },
  }
}
</script>

<style scoped>
.title-alert-disconnect {
  font-size: 17px;
  font-weight: 500;
  line-height: 20px;
  color: #515151;
}
</style>



// WEBPACK FOOTER //
// src/components/modals/ModalDeletionFBPages.vue